import SVG from 'react-inlinesvg'
import { useTranslation } from 'react-i18next'
import routePaths from '../../constants/routePaths'
import { useContextAppStatus } from '../../contexts/appStatusContext'
import { useEffect } from 'react'

const ErrorMessage = () => {
  const { t } = useTranslation()
  const { isReloadOnError, isErrorMessageVisible, errorMessageText } = useContextAppStatus()

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    if (isReloadOnError) {
      setTimeout(() => {
        window.location.replace(routePaths.HOME)
      }, 2 * 1000 * 60)
    }

    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [isReloadOnError])

  return isErrorMessageVisible ? (
    <div className="fixed left-0 top-0 flex h-screen w-screen items-center justify-center bg-white">
      <div className="w-[200px] whitespace-pre-wrap p-[10px] text-center max-sm:w-[220px] lg:w-[260px]">
        <SVG
          className="relative left-[15px] h-[100px] max-sm:h-[134px] lg:h-[224px]"
          src="/icons/error-guy.svg"
        />
        <p className="mx-0 my-[10px] font-approach-light text-[16px] leading-[28px] tracking-[0.2px] max-sm:leading-[22px] lg:my-[15px] lg:text-[22px] lg:leading-[34px]">
          {t(errorMessageText)}
        </p>
        {isReloadOnError ? (
          <button
            className="h-[36px] w-[180px] rounded-[18px] border-none bg-black p-0 text-white max-sm:w-[177px] lg:h-[44px] lg:w-[220px] lg:rounded-[22px]"
            onClick={() => window.location.replace(routePaths.HOME)}
          >
            <span className="font-approach-medium text-[16px] tracking-[1.06px] max-sm:text-[18px] lg:text-[22px]">
              {t('tryAgain')}
            </span>
          </button>
        ) : null}
      </div>
    </div>
  ) : null
}

export default ErrorMessage
